import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { createPortal } from 'react-dom';
import { Toaster } from '@client/src/components/ui/sonner';
import RoutesComponent from './app.tsx';
import './index.css';

const CLIENT_BASE_PATH = (
  (import.meta.env as Record<string, string | undefined>).CLIENT_BASE_PATH ||
  '/'
);

const ErrorFallback: React.FC<FallbackProps> = ({
  error,
  resetErrorBoundary,
}) => (
  <div
    role="alert"
    className="min-h-screen flex items-center justify-center bg-background px-4"
  >
    <div className="max-w-sm w-full bg-card rounded-lg border shadow-sm p-6 space-y-4">
      <div>
        <h2 className="text-base font-semibold text-foreground mb-2">
          出错了
        </h2>
        <p className="text-sm text-muted-foreground whitespace-pre-wrap break-words">
          {error instanceof Error ? error.message : String(error)}
        </p>
      </div>
      <button
        type="button"
        onClick={resetErrorBoundary}
        className="w-full h-10 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:opacity-90 transition-opacity"
      >
        重试
      </button>
    </div>
  </div>
);

const MainApp = () => {
  return (
    <BrowserRouter basename={CLIENT_BASE_PATH}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <RoutesComponent />
        {createPortal(<Toaster />, document.body)}
      </ErrorBoundary>
    </BrowserRouter>
  );
};

createRoot(document.getElementById('root')!).render(<MainApp />);
